import { render, staticRenderFns } from "./ImportantFundPerformanceInformation.vue?vue&type=template&id=ebfb7ff4"
import script from "./ImportantFundPerformanceInformation.vue?vue&type=script&lang=js"
export * from "./ImportantFundPerformanceInformation.vue?vue&type=script&lang=js"
import style0 from "./ImportantFundPerformanceInformation.vue?vue&type=style&index=0&id=ebfb7ff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports